/* eslint-disable react-hooks/exhaustive-deps */
import {observer} from "mobx-react";
import Utility from "../../Utility";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import {
    Button,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Tooltip
} from "@mui/material";
import React, {useEffect, useRef, useState} from "react";
import ConditionalComponent from "../Shared/ConditionalComponent";
import {responseEnum} from "../../serverClientShared/sharedEnums";
import OnBoardingInput from "./OnBoardingInput";
import verificationErrorSvg from "../../assets/img/verification-error.svg";
import {useStores} from "../../Hooks";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {routes} from "../../App";
import EllipsisContainer from "../Shared/EllipsisContainer";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import {Link} from "react-router-dom";
import TextField from "@mui/material/TextField";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import sharedUtils, {FAST_TRACK_DOMAIN} from "../../serverClientShared/sharedUtils";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import {history} from "../../index";
import Settings from '../../settings.json';
import Cookies from "js-cookie";
import {ReCAPTCHA} from "react-google-recaptcha-enterprise";

async function finishSignUp(generalStore, modalStore) {
    try {
        generalStore.isLoaderOpen = true;
        await generalStore.signUp();

    } catch (e) {
        modalStore.showErrorMessage(generalStore.translate('couldNotCreateUser'));
    }
    generalStore.isLoaderOpen = false;
}

function handleLoginError(e, modalStore, confirmText, confirmCallbackFunc, generalStore) {
    if (e.response) {
        if (e.response.status === responseEnum.TOO_MANY_REQUESTS) {
            // noinspection JSUnusedGlobalSymbols
            modalStore.modalData = {
                connections: e.response.data.connectionsList,
                maxConnectionsPerUser: e.response.data.maxConnectionsPerUser,
                confirmText,
                confirmCallback: () => {
                    modalStore.isTooManyConnectionsModalOpen = false;
                    confirmCallbackFunc();
                }
            };
            modalStore.isTooManyConnectionsModalOpen = true;
        } else if (e.response.status === responseEnum.ILLEGAL_ACTION) {
            modalStore.showErrorMessage(generalStore.translate('pleaseMakeSureYourUserRequestGotApprovedByAnAdmin'));
        } else if (e.response.status === responseEnum.NO_PERMISSION) {
            history.push(routes.MOBILE_USER)
        } else if (e.response.status === responseEnum.BLOCKED) {
            modalStore.isDomainBlockedModalOpen = true;
        } else if (e.response.status === responseEnum.EXPIRED) {
            modalStore.isDomainExpiredModalOpen = true;
        } else if (e.response.status === responseEnum.ALT_AUTH_REQUIRED) {
            modalStore.showErrorMessage(`${generalStore.translate('thisIsA PowerUser')}, ${generalStore.translate('approveThisLoginThrough', true)} ${generalStore.signInData.email}`);
        } else {
            modalStore.showErrorMessage(generalStore.translate('cannotConnectWithEmailPassword'));
        }
    } else {
        modalStore.showErrorMessage(generalStore.translate('cannotConnectWithEmailPassword'));
    }
}

export const SelectDomainStep = observer((props) => {
    const {generalStore, modalStore} = useStores();

    const {isSignup, isHpBranded} = props;
    const {activeDomains, invitedDomains, domainsDisplayedNames} = generalStore;
    const isLoadingDomains = modalStore.isLoadingWorkspaces
    const noResults = !invitedDomains || !activeDomains || !(invitedDomains.length + (isSignup ? 0 : activeDomains.length));
    const joinDomain = async (workspace) => {
        generalStore.isLoaderOpen = true;
        generalStore.signInData.workspace = workspace;
        generalStore.signInData.isNewDomain = false;
        if (isSignup) {
            try {
                await generalStore.signUp()
            } catch (e) {
                modalStore.showErrorMessage(generalStore.translate('couldNotCreateUser'));
            }
        } else {
            try {
                await generalStore.logIn();
            } catch (e) {
                handleLoginError(e, modalStore, generalStore.translate('join'), generalStore.logIn, generalStore);
            }
        }

        generalStore.isLoaderOpen = false;
    }
    const launchDomain = async (workspace) => {
        try {
            generalStore.isLoaderOpen = true;
            generalStore.signInData.workspace = workspace;
            generalStore.signInData.isNewDomain = false;
            await generalStore.logIn();

        } catch (e) {
            handleLoginError(e, modalStore, generalStore.translate('launch'), generalStore.logIn, generalStore);
        }
        generalStore.isLoaderOpen = false;
    }

    async function logOutFunc() {
        await generalStore.logOut();
    }

    return (
        <div className='on-boarding-step select-workspace' data-testid="select-workspace-step">
            <div className='step-title'>
                <ConditionalComponent if={!props.hideBack}>
                    <KeyboardBackspaceIcon onClick={props.goToBackStep} className='step-back'/>
                </ConditionalComponent>
                {generalStore.translate('selectWorkspace')}
            </div>

            <div className='step-form-line'/>


            <div className={'domains-list special-scroll' + ((!!noResults && !isLoadingDomains) ? ' no-results' : '')}>
                <ConditionalComponent if={!isSignup}>
                    {activeDomains.map(workspaceId => {
                        const fullDomain = Utility.getFullDomain(workspaceId, generalStore.workspace);
                        const workspaceName = domainsDisplayedNames.length ? generalStore.getDomainsDisplayedName(workspaceId) : workspaceId
                        return (
                            <div className='step-form-line domain-line' key={workspaceId}>
                                <div className='domain-title-description'>
                                    <EllipsisContainer value={workspaceName.toUpperCase()}>
                                        <div className='domain-title'>
                                            {workspaceName.toUpperCase()}
                                        </div>
                                    </EllipsisContainer>

                                    <ConditionalComponent if={!isHpBranded}>
                                        <EllipsisContainer value={fullDomain}>
                                            <div className='domain-description'>
                                                {fullDomain}
                                            </div>
                                        </EllipsisContainer>
                                    </ConditionalComponent>
                                </div>
                                <Button
                                    className='primary-button'
                                    variant='contained'
                                    onClick={() => launchDomain(workspaceId)}
                                >
                                    {generalStore.translate('launch')}
                                </Button>
                            </div>
                        )
                    })}
                </ConditionalComponent>
                {/*<ConditionalComponent if={domainsDisplayedNames && domainsDisplayedNames.length}>*/}
                {invitedDomains.map(workspaceId => {
                    const fullDomain = Utility.getFullDomain(workspaceId, generalStore.workspace);
                    const workspaceName = domainsDisplayedNames.length ? generalStore.getDomainsDisplayedName(workspaceId) : workspaceId
                    return (
                        <div className='step-form-line domain-line' key={workspaceId}>
                            <div className='domain-title-description'>

                                <EllipsisContainer value={workspaceName.toUpperCase()}>
                                    <div className='domain-title'>
                                        {workspaceName.toUpperCase()}
                                    </div>
                                </EllipsisContainer>

                                <ConditionalComponent if={!isHpBranded}>
                                    <EllipsisContainer value={fullDomain}>
                                        <div className='domain-description'>
                                            {fullDomain}
                                        </div>
                                    </EllipsisContainer>
                                </ConditionalComponent>
                            </div>
                            <Button
                                className='delete-button'
                                variant='contained'
                                onClick={() => joinDomain(workspaceId)}
                                data-testid={`join-workspace-${workspaceId}`}
                            >
                                {generalStore.translate('join')}
                            </Button>
                        </div>
                    )
                })}
                {/*</ConditionalComponent>*/}
            </div>

            <ConditionalComponent if={!!noResults && !isLoadingDomains}>
                <div className='step-form-line no-results-container'>
                    {generalStore.translate('noWorkspacesFound')}.
                </div>
            </ConditionalComponent>

            <ConditionalComponent if={isLoadingDomains}>
                <div className='step-form-line no-results-container'>
                    {generalStore.translate('searchingForWorkspaces')}.
                </div>
            </ConditionalComponent>

            <div className='step-form-line on-boarding-only'/>
            <div className='step-form-line on-boarding-only'/>
            <div className='create-workspace-expand-container on-boarding-only'>
                <div>
                    <Button
                        className='logout-button'
                        onClick={logOutFunc}
                    >
                        <span className='hide-in-mobile'>
                            {generalStore.translate('logInAsDifferentUser')}
                        </span>
                        <span className='show-in-mobile'>
                            {generalStore.translate('logout')}
                        </span>
                    </Button>
                </div>
            </div>

            <ConditionalComponent if={!!noResults}>
                <div className='step-form-line submit-container new-workspace-button-container'>
                    <ul>
                        <li className='mb-4'>{generalStore.translate('youMustBeInvitedInToAWorkspaceInOrderToLaunchIt')}.</li>
                    </ul>
                </div>
            </ConditionalComponent>
        </div>
    )
});


export const SelectDomainNameStep = observer((props) => {
    const {generalStore, modalStore} = useStores();

    const [domainIllegal, setDomainIllegal] = useState(false);
    const [blockInteraction, setBlockInteraction] = useState(false);

    const {workspace} = generalStore.signInData;
    let errorMessage = null;
    if (workspace) {
        errorMessage = sharedUtils.getIllegalDomainMessage(workspace);
    }
    const isDomainDisabled = domainIllegal || blockInteraction || !!errorMessage || workspace.length < 3;

    const checkDomainName = async () => {

        if (!generalStore.signInData.workspace || isDomainDisabled) {
            return;
        }
        setDomainIllegal(false);
        setBlockInteraction(true);

        try {
            const isOk = await generalStore.checkDomainLegal();
            if (isOk) {
                if (generalStore.workspace === FAST_TRACK_DOMAIN) {
                    await finishSignUp(generalStore, modalStore);
                } else {
                    props.goToNextStep();
                }
            } else {
                setDomainIllegal(true);
            }
        } catch (e) {
            console.error(e);
            modalStore.showErrorMessage(generalStore.translate('problemCheckingDomainName'))
        }
        setBlockInteraction(false);
    }

    return (
        <div className='on-boarding-step'>
            <div className='step-title'>
                <KeyboardBackspaceIcon onClick={props.goToBackStep} className='step-back'/>
                {generalStore.translate('companyName')}
            </div>
            <div className='step-form-line'>
                {generalStore.translate('thisWillBeTheNameInYourWorkspaceAddressChooseSomethingOfficial')}
            </div>
            <div className='step-form-line'>
                <div className='step-form-line'>
                    <OnBoardingInput
                        placeholder={generalStore.translate('forExample') + ': "lls", "lls-ltd"'}
                        dataKey='workspace'
                        onKeyDown={() => setDomainIllegal(false)}
                        error={!!errorMessage}
                        helperText={errorMessage}
                        autoFocus
                        onEnterPressed={checkDomainName}
                    />
                </div>
            </div>
            <ConditionalComponent if={domainIllegal}>
                <div className='step-form-line'>
                    <div className='error-container'>
                        <img src={verificationErrorSvg} alt=''/>
                        {generalStore.translate('nameIsNotAvailable')}
                    </div>
                </div>
                <div className='step-form-line'>
                    <div className='check-domain-error-secondary is-new'>
                        {generalStore.translate('companyNameMisusedSentence1')}
                        <a href='mailto:support@frontline.io' target='_blank' rel='noreferrer'>
                            {generalStore.translate('companyNameMisusedLink')}
                        </a>
                    </div>
                </div>
            </ConditionalComponent>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={checkDomainName}
                    disabled={isDomainDisabled}
                >
                    {generalStore.translate('verify')}
                </Button>
            </div>
        </div>
    )
});

export const ConfirmationStep = observer((props) => {
    const {generalStore, modalStore} = useStores();


    const {isSignup} = props;
    const {email, workspace, firstName, lastName} = generalStore.signInData;


    const login = async () => {
        try {
            generalStore.isLoaderOpen = true;
            await generalStore.logIn();

        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('couldNotCreateUser'));
        }
        generalStore.isLoaderOpen = false;
    }

    return (
        <div className='on-boarding-step'>
            <div className='step-title'>
                <KeyboardBackspaceIcon onClick={props.goToBackStep} className='step-back'/>
                {generalStore.translate('confirmation')}
            </div>
            <div className='confirmation-step-sides'>
                <div className='side confirmation-step-first-side'>
                    <ConditionalComponent if={!!isSignup}>
                        <div>
                            {generalStore.translate('userName')}:
                        </div>
                    </ConditionalComponent>
                    <ConditionalComponent if={!!email}>
                        <div>
                            {generalStore.translate('email')}:
                        </div>
                    </ConditionalComponent>
                    <div>
                        {generalStore.translate('workspace')}:
                    </div>
                </div>
                <div className='side confirmation-step-second-side'>
                    <ConditionalComponent if={!!isSignup}>
                        <div>
                            {firstName + ' ' + lastName}
                        </div>
                    </ConditionalComponent>
                    <div>
                        {email}
                    </div>
                    <div>
                        {workspace}
                    </div>
                </div>
            </div>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={() => isSignup ? finishSignUp(generalStore, modalStore) : login()}
                    data-testid="signup-confirm-button"
                >
                    {generalStore.translate('create')}
                </Button>
            </div>
        </div>
    )
});

const navigateToLoginDomain = (e, generalStore, route) => {
    const {workspace} = generalStore;
    const isLoginDomain = workspace === sharedUtils.LOGIN_DOMAIN;
    if (!isLoginDomain && workspace) {
        e.preventDefault();
        const {host, protocol} = window.location;
        window.location.href = `${protocol}//${host.replace(`${workspace}.`, `${sharedUtils.LOGIN_DOMAIN}.`)}${route}`;
    }
};

function renderOtherFlow(generalStore, firstText, inButtonText, route) {
    return <div className='other-boarding-link'>
        {firstText}

        <ConditionalComponent if={generalStore.workspace !== FAST_TRACK_DOMAIN}>
            <Link to={route} onClick={(e) => navigateToLoginDomain(e, generalStore, route)}>{inButtonText}</Link>
        </ConditionalComponent>

        <ConditionalComponent if={generalStore.workspace === FAST_TRACK_DOMAIN}>
            <span
                className='fast-track-sign-in-button'
                onClick={() => generalStore.fastTrackIsUser = !generalStore.fastTrackIsUser}
            >
                &nbsp;{inButtonText}
            </span>
        </ConditionalComponent>
    </div>;
}

export const MissingDetailsStep = observer(() => {
    const {generalStore, modalStore} = useStores();

    const {firstName, lastName, confirmPassword, password, oldPassword} = generalStore.signInData;
    const [isPasswordRevealed, setPasswordRevealed] = useState(false);
    const isPasswordError = password && !sharedUtils.isLegalPassword(password);
    const isConfirmPasswordError = confirmPassword && confirmPassword !== password;
    const isFormDisabled = !firstName || !lastName || !password || !confirmPassword || isPasswordError || isConfirmPasswordError;
    const [hintTooltipOpen, setHintTooltipOpen] = useState(false);

    async function submit() {
        if (isFormDisabled) {
            return;
        }
        const user = generalStore.userDetails;
        user.Password = password;
        user.oldPassword = oldPassword;
        user.Name = firstName;
        user.LastName = lastName;
        const promise = generalStore.updateUser(user);
        const errorMessage = generalStore.translate('cannotSetDetails');
        const loadingMessage = generalStore.translate('settingDetails') + '...';
        await modalStore.runAsync(promise, errorMessage, null, loadingMessage);
        window.location.reload();
    }

    return (
        <div className='on-boarding-step'>
            <div className='step-title'>
                {generalStore.translate('pleaseFillMissingDetails')}
            </div>
            <div className='step-form-line no-room-for-error'>
                <OnBoardingInput
                    className='semi'
                    placeholder={generalStore.translate('firstName')}
                    dataKey='firstName'
                    autoFocus
                />
                <OnBoardingInput
                    className='semi'
                    placeholder={generalStore.translate('surname')}
                    dataKey='lastName'
                />
            </div>
            <div className='step-form-line no-room-for-error'>

                <OnBoardingInput
                    autoComplete='password'
                    placeholder={generalStore.translate('oldPassword')}
                    dataKey='oldPassword'
                    type='password'
                />
            </div>
            <div className='step-form-line  no-room-for-error'>
                <OnBoardingInput
                    autoComplete='password'
                    placeholder={generalStore.translate('newPassword')}
                    dataKey='password'
                    error={!!isPasswordError}
                    helperText={isPasswordError ? generalStore.translate('passwordIsInvalid') : ''}
                    type={isPasswordRevealed ? 'text' : 'password'}
                />
                <IconButton className='show-hide-password' onClick={() => setPasswordRevealed(!isPasswordRevealed)}>
                    {!isPasswordRevealed ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                </IconButton>
                <Tooltip
                    open={hintTooltipOpen} onClose={() => setHintTooltipOpen(false)}
                    arrow
                    title={"Password needs to at least 1 capital letter, 1 small letter, 1 number and 1 special character."}
                >
                    <div
                        className='password-hint'
                        onClick={() => setHintTooltipOpen(true)}
                        onMouseEnter={() => setHintTooltipOpen(true)}
                    >i
                    </div>
                </Tooltip>
            </div>
            <div className='step-form-line'>
                <OnBoardingInput
                    placeholder={generalStore.translate('confirmPassword')}
                    dataKey='confirmPassword'
                    error={!!isConfirmPasswordError}
                    helperText={isConfirmPasswordError ? generalStore.translate('passwordsAreNotTheSame') : ''}
                    type='password'
                />
            </div>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={submit}
                    disabled={isFormDisabled}
                >
                    {generalStore.translate('submit')}
                </Button>
            </div>
        </div>
    )

});
export const SignupPersonalDetailsStep = observer((props) => {
    const {generalStore, modalStore} = useStores();

    const {firstName, lastName, confirmPassword, email, password} = generalStore.signInData;

    const isEmailError = email && !Utility.verifyEmail(email);
    const [isPasswordRevealed, setPasswordRevealed] = useState(false);
    const isPasswordError = password && !sharedUtils.isLegalPassword(password);
    const isConfirmPasswordError = confirmPassword && confirmPassword !== password;
    const isFormDisabled = !firstName || !lastName || !email || !password || !confirmPassword ||
        isEmailError || isPasswordError || isConfirmPasswordError;
    const [hintTooltipOpen, setHintTooltipOpen] = useState(false);

    const createPendingUser = async () => {
        if (isFormDisabled) {
            return;
        }

        try {
            await generalStore.createPendingUser(props.isConvention);
            props.goToNextStep();
            modalStore.showSuccessMessage(`${generalStore.translate('verificationEmailSentSentence1_beforeEmail')} ${email}${generalStore.translate('verificationEmailSentSentence2_afterEmail')}`);
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('problemCreatingNewUser'));
        }
    };

    return (
        <div className={`on-boarding-step${!!props.isConvention ? ' convention' : ''}`}>
            <div className='step-title'>
                <KeyboardBackspaceIcon onClick={() => history.push(routes.LOGIN)} className='step-back'/>
                {generalStore.translate('signUp')}
            </div>
            <div className='step-form-line no-room-for-error'>
                <OnBoardingInput
                    className='semi'
                    placeholder={generalStore.translate('firstName')}
                    dataKey='firstName'
                    autoFocus
                    onEnterPressed={createPendingUser}
                    data-testid="first-name-input"
                />
                <OnBoardingInput
                    className='semi'
                    placeholder={generalStore.translate('surname')}
                    dataKey='lastName'
                    onEnterPressed={createPendingUser}
                    data-testid="last-name-input"
                />
            </div>
            <ConditionalComponent if={!props.isConvention}>
                <div className='step-form-line info'>
                    {generalStore.translate('weRecommendYouUseYourWorkAddress')}
                </div>
            </ConditionalComponent>
            <div className='step-form-line'>
                <OnBoardingInput
                    placeholder={generalStore.translate('email')}
                    dataKey='email'
                    error={!!isEmailError}
                    helperText={isEmailError ? generalStore.translate('emailIsInvalid') : ''}
                    onEnterPressed={createPendingUser}
                    disabled={generalStore.signInData.isInvited}
                    data-testid="signup-email-input"
                />
            </div>
            <div className='step-form-line with-hint'>
                <OnBoardingInput
                    autoComplete='password'
                    placeholder={generalStore.translate('password')}
                    dataKey='password'
                    error={!!isPasswordError}
                    helperText={isPasswordError ? generalStore.translate('passwordIsInvalid') : ''}
                    type={isPasswordRevealed ? 'text' : 'password'}
                    onEnterPressed={createPendingUser}
                    data-testid="signup-password-input"
                />
                <IconButton className='show-hide-password' onClick={() => setPasswordRevealed(!isPasswordRevealed)}>
                    {!isPasswordRevealed ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                </IconButton>
                <Tooltip
                    open={hintTooltipOpen} onClose={() => setHintTooltipOpen(false)}
                    arrow
                    title={"Password needs to at least 1 capital letter, 1 small letter, 1 number and 1 special character."}
                >
                    <div
                        className='password-hint'
                        onClick={() => setHintTooltipOpen(true)}
                        onMouseEnter={() => setHintTooltipOpen(true)}
                    >i
                    </div>
                </Tooltip>
            </div>
            <div className='step-form-line'>
                <OnBoardingInput
                    placeholder={generalStore.translate('confirmPassword')}
                    dataKey='confirmPassword'
                    error={!!isConfirmPasswordError}
                    helperText={isConfirmPasswordError ? generalStore.translate('passwordsAreNotTheSame') : ''}
                    type='password'
                    onEnterPressed={createPendingUser}
                    data-testid="signup-confirm-password-input"
                />
            </div>
            <ConditionalComponent if={!props.isConvention}>
                <div className='step-form-line links'>
                    {generalStore.translate('byContinuing') + ', ' + generalStore.translate('you\'reAgreeingToOurCustomer', true)}
                    <a href='https://frontline.io/terms-of-service' target='_blank' rel='noreferrer'>
                        {generalStore.translate('termsOfService')}
                    </a>.
                </div>
            </ConditionalComponent>
            <div className='step-form-line submit-container'>
                <ConditionalComponent if={props.isConvention}>
                    <div className='step-form-line links'>
                        {generalStore.translate('byContinuing') + ', ' + generalStore.translate('you\'reAgreeingToOurCustomer', true)}
                        <a href='https://frontline.io/terms-of-service' target='_blank' rel='noreferrer'>
                            {generalStore.translate('termsOfService')}
                        </a>.
                    </div>
                </ConditionalComponent>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={createPendingUser}
                    disabled={isFormDisabled}
                    data-testid="signup-continue-button"
                >
                    {generalStore.translate('continue')}
                </Button>
                <ConditionalComponent if={!props.isConvention}>
                    {renderOtherFlow(generalStore, generalStore.translate('alreadyHaveAnAccount'), generalStore.translate('signIn'), routes.LOGIN)}
                </ConditionalComponent>
            </div>
        </div>
    )
});

export const EmailVerificationStep = observer((props) => {
    const {generalStore, modalStore} = useStores();

    const [verificationArr, setVerificationArr] = useState(['', '', '', '', '']);
    const [verificationFailed, setVerificationFailed] = useState(false);
    const [blockInteraction, setBlockInteraction] = useState(false);
    const [preventResendTimer, setPreventResendTimer] = useState(30);
    const refs = [];

    useEffect(() => {
        startResendTimer();
    }, [generalStore, props]);


    const isVerificationEmpty = !!verificationArr.filter(verificationChar => verificationChar === '').length;

    const verify = async () => {
        if (isVerificationEmpty) {
            return;
        }
        setBlockInteraction(true);
        const verificationCode = verificationArr.join('');
        try {
            if (props.isConvention) {
                generalStore.isLoaderOpen = true;
                await generalStore.verifyUser(verificationCode, true);
                generalStore.isLoaderOpen = false;
            } else {
                await generalStore.verifyUser(verificationCode);
                props.goToNextStep();
            }
            generalStore.isLoaderOpen = false;
        } catch (e) {
            setVerificationFailed(true);
        }
        setBlockInteraction(false);
    };

    const onChange = (event, i) => {
        let {value} = event.target;
        if (isNaN(value)) {
            return;
        }
        setVerificationFailed(false);
        if (value.length > 1) {
            value = value[value.length - 1];
        }
        verificationArr[i] = value;
        setVerificationArr([...verificationArr]);
        if (i < verificationArr.length - 1) {
            refs[i + 1].focus();
        }
    }

    const setInputRef = ref => {
        refs.push(ref);
    }

    const handlePaste = (event) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData('Text');
        if (pasteData && pasteData.length === refs.length && /^\d+$/.test(pasteData)) {
            const newVerificationArr = [];
            pasteData.split('').forEach(number => newVerificationArr.push(number));
            setVerificationArr([...newVerificationArr])
        }
    }

    const handleBackSpace = (event, i) => {
        if (event.key !== 'Backspace') {
            return;
        }
        if (i > 0) {

            let indexToDelete;
            if (i === verificationArr.length - 1 && verificationArr[i]) {
                indexToDelete = i;
            } else {
                indexToDelete = i - 1;
            }
            verificationArr[indexToDelete] = '';
            setVerificationArr([...verificationArr]);
            refs[indexToDelete].focus();
            event.preventDefault();
        }
    }

    function startResendTimer() {
        let timer = 30;
        const timerInterval = setInterval(() => {
            if (!timer) {
                clearInterval(timerInterval);
            }
            setPreventResendTimer(timer);
            timer--;
        }, 1000);
    }

    async function resend() {
        try {
            startResendTimer();
            await generalStore.resendVerificationCode();
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('cannotResendCode'));
            console.error(e);
        }
    }

    return (

        <div className={`on-boarding-step${!!props.isConvention ? ' convention' : ''}`}>
            <div className='step-title'>
                <KeyboardBackspaceIcon onClick={props.goToBackStep} className='step-back'/>
                {generalStore.translate('emailVerification')}
            </div>
            <div className='step-description'>
                {generalStore.translate('verificationCodeSentSentence1_beforeBoldedEmail')}&nbsp;
                <strong>{generalStore.signInData.email}</strong>
                {generalStore.translate('verificationCodeSentSentence2_afterBoldedEmail')}<br/>
                {generalStore.translate('codeWillExpireIn10Minutes')}
            </div>
            <div className='step-form-line'>
                <div className='verification-container'>
                    {verificationArr.map((verificationChar, i) => (
                        <TextField
                            type="number"
                            autoFocus={i === 0}
                            key={i}
                            onPaste={handlePaste}
                            className='verification-input'
                            variant='standard'
                            value={verificationChar}
                            onChange={e => onChange(e, i)}
                            onKeyDown={async e => {
                                if (e.key === 'Enter') {
                                    await verify();
                                } else {
                                    handleBackSpace(e, i);
                                }
                            }}
                            inputRef={setInputRef}
                            inputProps={{
                                "data-testid": `verification-input-${i}`
                            }}
                        />
                    ))}
                </div>
                <Button
                    onClick={resend}
                    className='resend-button'
                    variant='contained'
                    disabled={!!preventResendTimer}
                >
                    {generalStore.translate('resend')} {preventResendTimer ? '(' + preventResendTimer + ')' : null}
                </Button>
            </div>
            <div className='step-form-line'>
                <ConditionalComponent if={verificationFailed}>
                    <div className='error-container'>
                        <img src={verificationErrorSvg} alt=''/>
                        {generalStore.translate('codeIncorrect')}
                    </div>
                </ConditionalComponent>
            </div>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={verify}
                    disabled={blockInteraction || isVerificationEmpty}
                    data-testid="verify-button"
                >
                    {generalStore.translate('verify')}
                </Button>
            </div>
        </div>
    )
});

export const SelectFastTrackDestinationStep = observer(() => {
    const {generalStore, modalStore} = useStores();
    const [selectedWorkspace, setSelectedWorkspace] = useState(null);
    const [selectedProjectId, setSelectedProjectId] = useState(null);
    const [createNewProject, setCreateNewProject] = useState(false);
    useEffect(() => {
        if (generalStore.activeDomains.length === 1) {
            setSelectedWorkspace(generalStore.activeDomains[0]);
        }
    }, [generalStore.activeDomains]);

    useEffect(() => {
        if (!selectedWorkspace) {
            return;
        }

        const promise = generalStore.getFastTrackProjects(selectedWorkspace);
        const errorMessage = generalStore.translate('cannotGetProjects');
        const loadingMessage = generalStore.translate('gettingProjects') + '...';
        modalStore.runAsync(promise, errorMessage, null, loadingMessage).then();

    }, [selectedWorkspace])
    // TODO what if no domains
    return (
        <div className='on-boarding-step'>
            <div className='select-workspace-description'>
                {generalStore.translate('selectProjectToInsertConvertedFileInTo')}:
            </div>
            <div className='step-form-line'>
                <FormControl fullWidth>
                    <InputLabel
                        shrink
                        id="workspace-select-label"
                        className='select-label'
                    >
                        {generalStore.translate('workspace')}
                    </InputLabel>
                    <Select
                        disableUnderline
                        className='select'
                        labelId="workspace-select-label"
                        IconComponent={ExpandMoreIcon}
                        value={selectedWorkspace || ''}
                        onChange={e => setSelectedWorkspace(e.target.value)}
                        disabled={generalStore.activeDomains.length === 1}
                        MenuProps={{
                            getContentAnchorEl: null,
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "center",
                            }
                        }}
                    >
                        {generalStore.activeDomains.map((workspace, i) =>
                            <MenuItem value={workspace} key={workspace + i}>
                                {sharedUtils.strToCapital(generalStore.getDomainName(workspace))}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>
            </div>

            <ConditionalComponent if={!!generalStore.fastTrackCanCreateProjects}>
                <div className='step-form-line no-room-for-error'>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color='primary'
                                checked={createNewProject}
                                onChange={e => setCreateNewProject(e.target.checked)}
                            />
                        }
                        label={generalStore.translate('createNewProject')}
                    />
                </div>
            </ConditionalComponent>

            <div className='step-form-line'>
                <FormControl fullWidth>
                    <InputLabel
                        id="project-select-label"
                        className='select-label'
                        shrink
                    >
                        {generalStore.translate('project')}
                    </InputLabel>
                    <Select
                        disableUnderline
                        className='select'
                        labelId="project-select-label"
                        disabled={!selectedWorkspace || createNewProject}
                        value={selectedProjectId || ''}
                        onChange={e => setSelectedProjectId(e.target.value)}
                        IconComponent={ExpandMoreIcon}
                        MenuProps={{
                            getContentAnchorEl: null,
                            anchorOrigin: {
                                vertical: "bottom",
                                horizontal: "center",
                            }
                        }}
                    >
                        {generalStore.fastTrackProjectsList.map(project =>
                            <MenuItem value={project.ProjectIdentifier}>
                                {sharedUtils.strToCapital(project.ProjectName)}
                            </MenuItem>
                        )}
                    </Select>
                </FormControl>

            </div>


            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={async () => {
                        try {
                            generalStore.isLoaderOpen = true;
                            generalStore.fastTrackProjectId = selectedProjectId;
                            generalStore.signInData.workspace = selectedWorkspace;
                            generalStore.signInData.isNewDomain = false;
                            await generalStore.logIn();

                        } catch (e) {
                            if (!!e.response && e.response.status === responseEnum.ALT_AUTH_REQUIRED) {
                                modalStore.showErrorMessage(`${generalStore.translate('thisIsA PowerUser')}, ${generalStore.translate('approveThisLoginThrough', true)} ${generalStore.signInData.email}`);
                            } else modalStore.showErrorMessage(generalStore.translate('couldNotLogin'));
                        }
                        generalStore.isLoaderOpen = false;
                    }}
                    disabled={!selectedWorkspace || (!selectedProjectId && !createNewProject)}
                >
                    {generalStore.translate('next')} <ArrowForwardIcon/>
                </Button>
            </div>
        </div>
    );
});

export const EnterDeviceLoginCodeStep = observer((props) => {
    const {generalStore} = useStores();

    const [codeArr, setCodeArr] = useState(['', '', '', '', '', '']);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const deviceCode = urlParams.get('device-code');
        if (deviceCode) {
            generalStore.deviceLoginCode = deviceCode;
            props.goToNextStep();
        }
    }, [])

    const refs = [];


    const isCodeEmpty = !!codeArr.filter(char => char === '').length;

    const onChange = (event, i) => {
        let {value} = event.target;
        if (isNaN(value)) {
            return;
        }
        if (value.length > 1) {
            value = value[value.length - 1];
        }
        codeArr[i] = value;
        setCodeArr([...codeArr]);
        if (i < codeArr.length - 1) {
            refs[i + 1].focus();
        }
    }

    const setInputRef = ref => {
        refs.push(ref);
    }

    const handlePaste = (event) => {
        event.preventDefault();
        const pasteData = event.clipboardData.getData('Text');
        if (pasteData && pasteData.length === refs.length && /^\d+$/.test(pasteData)) {
            const codeArr = [];
            pasteData.split('').forEach(number => codeArr.push(number));
            setCodeArr([...codeArr])
        }
    }

    const handleBackSpace = (event, i) => {
        if (event.key !== 'Backspace') {
            return;
        }
        if (i > 0) {

            let indexToDelete;
            if (i === codeArr.length - 1 && codeArr[i]) {
                indexToDelete = i;
            } else {
                indexToDelete = i - 1;
            }
            codeArr[indexToDelete] = '';
            setCodeArr([...codeArr]);
            refs[indexToDelete].focus();
            event.preventDefault();
        }
    }
    const next = async () => {
        if (isCodeEmpty) {
            return;
        }
        generalStore.deviceLoginCode = codeArr.join('');
        props.goToNextStep();
    };


    return (

        <div className='on-boarding-step enter-code'>
            <div className='step-title'>
                {generalStore.translate('fillTheCodeFromYourDevice')}
            </div>
            <div className='step-form-line'>
                <div className='verification-container'>
                    {codeArr.map((char, i) => (
                        <TextField
                            autoFocus={i === 0}
                            key={i}
                            onPaste={handlePaste}
                            className='verification-input'
                            variant='standard'
                            value={char}
                            onChange={e => onChange(e, i)}
                            onKeyDown={async e => {
                                if (e.key === 'Enter') {
                                    await next();
                                } else {
                                    handleBackSpace(e, i);
                                }
                            }}
                            inputRef={setInputRef}
                            inputProps={{type: 'tel'}}
                        />
                    ))}
                </div>
            </div>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={next}
                    disabled={isCodeEmpty}
                >
                    {generalStore.translate('next')}
                </Button>
            </div>
        </div>
    )
});

async function loginWithHP(generalStore, rtcStore, isEmployeeSSO) {
    const ssoType = isEmployeeSSO ? 'employee' : 'customer';
    const {credentialsUrl, clientId} = Settings.hp[ssoType];
    if (generalStore.isOpenInApp) {
        const date = new Date();
        date.setTime(date.getTime() + (60 * 1000));
        Cookies.set('close_tab', 1, {expires: date})
        if (!isEmployeeSSO) {
            const logoutUrl = `https://${credentialsUrl}` + (
                isEmployeeSSO
                    ? `${sharedUtils.HP_EMPLOYEE_LOGOUT_URL}?post_logout_redirect_uri=${encodeURI(Settings.hp.redirectUrl)}&TargetResource=${encodeURI(Settings.hp.redirectUrl)}`
                    : `/directory/v1/oauth/logout?post_logout_redirect_uri=${encodeURI(Settings.hp.redirectUrl)}&TargetResource=${encodeURI(Settings.hp.redirectUrl)}`
            );
            window.open(logoutUrl);
        }
    }
    const authUrl = isEmployeeSSO ? `https://${credentialsUrl}/as/authorization.oauth2` : `https://${Settings.hp.customer.credentialsUrl}/directory/v1/oauth/authorize`;
    const scope = isEmployeeSSO ? 'openid_group' : 'user.profile.read';
    let state = Settings.hp.state;
    state += `_customer=${isEmployeeSSO ? 0 : 1}`;
    state += `_workspace=${generalStore.workspace}`;
    state += `_redirect=${generalStore.redirectToAfterLogin}`;
    if (rtcStore.emailToInvite) {
        state += `_emailToInvite=${rtcStore.emailToInvite}`;
    }
    state += `_openapp=${generalStore.isOpenInApp ? 1 : 0}`;
    if (!!generalStore.deviceLoginCode) {
        state += `_devicecode=${generalStore.deviceLoginCode}`;
    }
    // noinspection UnnecessaryLocalVariableJS
    const hpURL =
        `${authUrl}?` +
        `response_type=code` +
        `&client_id=${clientId}` +
        `&redirect_uri=${encodeURI(Settings.hp.redirectUrl)}` +
        `&scope=${scope}` +
        `&state=${state}` +
        `&allow_return=true`;

    window.location.href = hpURL;
}

export const SSOStep = observer(({isHpBranded}) => {
    const {generalStore, rtcStore} = useStores();
    return (
        <div className='on-boarding-step'>
            <div className='step-title'>
                {generalStore.translate('selectLoginOption')}
            </div>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant={isHpBranded ? 'contained' : 'outlined'}
                    onClick={() => loginWithHP(generalStore, rtcStore, false)}
                >
                    {generalStore.translate('signInAs') + ' HP ' + generalStore.translate('customer', true)}
                </Button>
                <Button
                    className='step-submit'
                    variant={isHpBranded ? 'contained' : 'outlined'}
                    onClick={() => loginWithHP(generalStore, rtcStore, true)}
                >
                    {generalStore.translate('signInAs') + ' HP ' + generalStore.translate('employee', true)}
                </Button>
                <span className='hp-login-disclaimer-text'>
                    {generalStore.translate('An') + ' HP xRServices ' + generalStore.translate('licenseIsRequiredToAccessThisContent.') + ' ' + generalStore.translate('ContactYour') + ' HP ' + generalStore.translate('Sales') + ' ' + generalStore.translate('RepresentativeForFurtherInformation.') + ' ' + generalStore.translate('FindOutMoreAbout') + ' HP xRServices '}<span
                    className='hp-link'
                    onClick={() => window.open('https://www.hp.com/us-en/industrial-printers/xrservices.html', '_blank')}>{generalStore.translate('Here')}</span>
                </span>
            </div>
        </div>
    )

});
export const PasswordStep = observer((props) => {
    const {generalStore, modalStore} = useStores();
    const {email, password} = generalStore.signInData;
    const [isPasswordRevealed, setPasswordRevealed] = useState(false);
    const [verificationResult, setVerificationResult] = useState(null);
    const recaptchaRef = useRef(null);
    const grecaptchaObject = window.grecaptcha

    const getDomains = async () => {
        if (!email || !password || (generalStore.isToManyLoginAttempts && !verificationResult)) {
            return;
        }

        try {
            generalStore.isLoaderOpen = true;
            await generalStore.getDomainsOrLogin(verificationResult);

            if (!generalStore.workspace || [sharedUtils.LOGIN_DOMAIN, sharedUtils.FAST_TRACK_DOMAIN, sharedUtils.DEVICE_LOGIN_DOMAIN, sharedUtils.HP_DEVICE_LOGIN_DOMAIN].includes(generalStore.workspace)) {
                props.goToNextStep()
            }
        } catch (e) {
            if (e.response && e.response.status === responseEnum.TOO_MANY_REQUESTS) {
                modalStore.modalData = {
                    connections: e.response.data.connectionsList,
                    maxConnectionsPerUser: e.response.data.maxConnectionsPerUser,
                    confirmText: generalStore.translate('launch'),
                    confirmCallback: generalStore.getDomainsOrLogin
                };
                modalStore.isTooManyConnectionsModalOpen = true;
            } else if (e.response && e.response.status === responseEnum.ALT_AUTH_REQUIRED) {
                modalStore.showErrorMessage(`${generalStore.translate('thisIsA PowerUser')}, ${generalStore.translate('approveThisLoginThrough', true)} ${generalStore.signInData.email}`);
            } else {
                await generalStore.checkToManyLoginAttempts(email)
                setVerificationResult(null)
                modalStore.showErrorMessage(generalStore.translate('cannotConnectWithEmailPassword'));
            }
        }
        generalStore.isLoaderOpen = false;
    };

    const onChange = async (value) => {
        setVerificationResult(value);
    };

    return (
        <div className='on-boarding-step'>
            <div className='step-title'>
                <ConditionalComponent if={!props.hideBack}>
                    <KeyboardBackspaceIcon onClick={props.goToBackStep} className='step-back'/>
                </ConditionalComponent>
                {generalStore.translate('password')}
            </div>
            <div className='step-form-line'>
                <OnBoardingInput
                    placeholder={generalStore.translate('password')}
                    dataKey='password'
                    autoFocus
                    type={isPasswordRevealed ? 'text' : 'password'}
                    onEnterPressed={getDomains}
                    data-testid="password-input"
                />
                <IconButton className='show-hide-password' onClick={() => setPasswordRevealed(!isPasswordRevealed)}>
                    {!isPasswordRevealed ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                </IconButton>
            </div>

            <ConditionalComponent if={generalStore.isToManyLoginAttempts && !verificationResult}>
                <ReCAPTCHA
                    ref={recaptchaRef}
                    sitekey="6LfIxCwqAAAAAAf2mUe7ti2gA4vOr4_ALripANh1"
                    grecaptcha={grecaptchaObject}
                    onChange={onChange}
                    style={{
                        marginTop: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                />
            </ConditionalComponent>

            <ConditionalComponent if={generalStore.workspace !== FAST_TRACK_DOMAIN}>
                <div className='step-form-line'>
                    <div className='other-boarding-link'>
                        <Link to={routes.FORGOT_PASSWORD} onClick={(e) => navigateToLoginDomain(e, generalStore, routes.FORGOT_PASSWORD)}>
                            {generalStore.translate('forgotYourPassword')}
                        </Link>
                    </div>
                </div>
            </ConditionalComponent>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={getDomains}
                    disabled={!email || !password || (generalStore.isToManyLoginAttempts && !verificationResult)}
                    data-testid="login-button"
                >
                    {generalStore.translate('login')}
                </Button>
                {renderOtherFlow(generalStore, generalStore.translate('dontHaveAnAccount'), generalStore.translate('signUp'), routes.SIGNUP)}
            </div>
        </div>
    );
});
export const EmailStep = observer((props) => {
    const {generalStore, modalStore} = useStores();
    const {email} = generalStore.signInData;

    async function getIsUserSSO() {
        if (!email) {
            return;
        }
        try {
            generalStore.isLoaderOpen = true;
            const {url} = await generalStore.getIsUserSSO(email);
            if (url) {
                window.location.href = url;
                return;
            }

            props.goToNextStep();
        } catch (e) {
            modalStore.showErrorMessage(generalStore.translate('pleaseContactSupport'));
        }
        generalStore.isLoaderOpen = false;
    }


    return (
        <div className='on-boarding-step'>
            <div className='step-title'>
                <ConditionalComponent if={!props.hideBack}>
                    <KeyboardBackspaceIcon onClick={props.goToBackStep} className='step-back'/>
                </ConditionalComponent>
                {generalStore.translate('login')}
            </div>
            <div className='step-form-line no-room-for-error'>
                <OnBoardingInput
                    placeholder={generalStore.translate('email')}
                    dataKey='email'
                    autoFocus
                    onEnterPressed={getIsUserSSO}
                    autoComplete="email"
                    data-testid="email-input"
                />
            </div>
            <div className='step-form-line submit-container'>
                <Button
                    className='step-submit'
                    variant='contained'
                    onClick={getIsUserSSO}
                    disabled={!email}
                    data-testid="continue-button"
                >
                    {generalStore.translate('continue')}
                </Button>
                {renderOtherFlow(generalStore, generalStore.translate('dontHaveAnAccount'), generalStore.translate('signUp'), routes.SIGNUP)}
            </div>
        </div>
    );
});


export const LoginFlow = observer(({steps, withoutStepper, isHpBranded, isDeviceLogin}) => {
    const {generalStore} = useStores();
    const [activeStep, setActiveStep] = useState(0);
    const [noStepZero, setNoStepZero] = useState(false);
    const [isBack, setIsBack] = useState(false);

    useEffect(() => {   //TODO check if needs dependencies
        if ((!withoutStepper || generalStore.workspaceIsHP) && activeStep === 0 && !isBack) {
            generalStore.isLoaderOpen = true;
            generalStore.getDomainsOrLogin().then(isShowDomains => {
                if (isShowDomains) {
                    setActiveStep(isHpBranded && !isDeviceLogin ? 1 : 2);
                    setNoStepZero(true);
                }
            }).catch(() => {
            }).finally(() => {
                generalStore.isLoaderOpen = false;
            });
        }
    }, []);

    useEffect(() => {
        if (isHpBranded) {
            Utility.replaceFaviconsAndTitle('hp', "xRServices");
        }

    }, [isHpBranded]);

    const StepComponent = steps[activeStep].component;

    if (generalStore.deepLinkLoginDone) {
        return <div className='on-boarding-box-container'>
            <div className='on-boarding-step'>
                <div className='step-title'>{generalStore.translate('successfulLogin')}</div>
                <br/>
                <div className='step-form-line info'>
                    {generalStore.translate('pleaseCloseThisBrowserWindowAndReturnToTheApp')}
                </div>
            </div>
        </div>
    }

    return (
        <>
            <ConditionalComponent
                if={isHpBranded && ((activeStep === 0 && !isDeviceLogin) || (activeStep === 1 && !!isDeviceLogin))}>
                <div className='bottom-half-white'/>
            </ConditionalComponent>
            <div
                className={`on-boarding-box-container step-${String(activeStep)}${isHpBranded ? ' hp-branded' : ''}${isDeviceLogin ? ' device-login' : ''}`}>

                <ConditionalComponent if={!withoutStepper}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                        {steps.map((step, i) => (
                            <Step key={generalStore.translate(step.label) + i}>
                                <StepLabel>{generalStore.translate(step.label)}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </ConditionalComponent>
                <StepComponent
                    isHpBranded={isHpBranded}
                    goToNextStep={() => setActiveStep(activeStep + 1)}
                    goToBackStep={() => {
                        setActiveStep(activeStep - 1);
                        setIsBack(true)
                    }}
                    hideBack={(noStepZero && activeStep === 1) || !activeStep}
                />
            </div>
        </>
    );
});

export const SignupFlow = observer(({steps, withoutStepper, isConvention}) => {
    const {generalStore} = useStores();
    const [activeStep, setActiveStep] = useState(0);
    const StepComponent = steps[activeStep].component;
    return (
        <div className={`on-boarding-box-container${!!isConvention ? ' convention' : ''}`}>
            <ConditionalComponent if={!withoutStepper}>
                <Stepper activeStep={activeStep} alternativeLabel>
                    {steps.map((step, i) => (
                        <Step key={generalStore.translate(step.label) + i}>
                            <StepLabel>{generalStore.translate(step.label)}</StepLabel>
                        </Step>
                    ))}
                </Stepper>
            </ConditionalComponent>
            <StepComponent
                isSignup
                isConvention={isConvention}
                goToNextStep={() => setActiveStep(activeStep + 1)}
                goToBackStep={() => setActiveStep(activeStep - 1)}
            />
        </div>
    )
});
